
/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'format_shapes': {
    width: 16,
    height: 16,
    viewBox: '0 0 22 22',
    data: '<path pid="0" d="M22 6V0h-6v2H6V0H0v6h2v10H0v6h6v-2h10v2h6v-6h-2V6zM2 2h2v2H2V2zm2 18H2v-2h2v2zm12-2H6v-2H4V6h2V4h10v2h2v10h-2v2zm4 2h-2v-2h2v2zM18 4V2h2v2zm-5.27 9H9.24l-.73 2H6.89l3.4-9h1.4l3.41 9h-1.63l-.74-2zm-3.04-1.26h2.61L11 7.91l-1.31 3.83z" _fill="#d9d9d9" fill-rule="evenodd"/>'
  }
})
